/* src/app/shared/components/ag-avatar/ag-avatar.component.scss */
.white-icon {
  filter: brightness(0) invert(1) !important;
}
.white-text {
  color: #ffffff !important;
}
.icon-avatar {
  width: 24px !important;
  height: 24px !important;
  filter: brightness(0) saturate(100%) invert(65%);
}
.stacked-avatars {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.stacked-display-case {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: fit-content;
}
.avatar-circle-small {
  width: 24px !important;
  height: 24px !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0px 2px 10px 0px rgba(34, 34, 34, 0.1);
}
.avatar-circle-small .avatar {
  width: 24px !important;
  height: 24px !important;
}
.avatar-circle-small p {
  font-size: 12px !important;
  color: #a6a6a6;
}
.avatar-circle-small .icon-avatar {
  width: 16px !important;
  height: 16px !important;
}
.avatar-circle-medium {
  width: 48px !important;
  height: 48px !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0px 2px 10px 0px rgba(34, 34, 34, 0.1);
}
.avatar-circle-medium .avatar {
  width: 48px !important;
  height: 48px !important;
}
.avatar-circle-medium p {
  font-size: 14px !important;
  color: #a6a6a6;
}
.avatar-circle-large {
  width: 56px !important;
  height: 56px !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0px 2px 10px 0px rgba(34, 34, 34, 0.1);
}
.avatar-circle-large .avatar {
  width: 56px !important;
  height: 56px !important;
}
.avatar-circle-large p {
  font-size: 16px !important;
  color: #a6a6a6;
}
.avatar-circle-extralarge {
  width: 80px !important;
  height: 80px !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0px 2px 10px 0px rgba(34, 34, 34, 0.1);
}
.avatar-circle-extralarge .avatar {
  width: 80px !important;
  height: 80px !important;
}
.avatar-circle-extralarge p {
  font-size: 16px !important;
  color: #a6a6a6;
}
/*# sourceMappingURL=ag-avatar.component.css.map */
